import Typography from '@mui/material/Typography'
import Grid from '@mui/material/Grid'
import { lighten, useTheme } from '@mui/material/styles'
import { FormSectionProps } from '../../interfaces/form'
import { useForm } from 'react-final-form'
import Box from '@mui/material/Box'
import Container from '@mui/material/Container'

import FormWizard from '../wizard'
import FormRadio from '../../components/FormRadio'

const radioStyle = {
  paddingBottom: 0,
  display: 'none',
}

const radioOverrideMuiStyle = {
  '&.MuiRadio-root': {
    '&.Mui-checked + span': {
      backgroundColor: `primary.main`,
      color: '#FFF !important',
    },
  },
}

const textStyle = {
  justifyContent: 'center',
  alignItems: 'center',
  borderRadius: '4px',
  display: 'inline-flex',
  borderColor: 'primary.main',
  borderWidth: 1,
  borderStyle: 'solid',
  marginTop: 0,
  marginRight: '6px',
  marginBottom: '10px',
  fontWeight: 'bold',
  verticalAlign: 'top',
  width: '100%',
  height: '100%',
  minHeight: 80,
  cursor: 'pointer',
}

const LivingStatus = ({ validate }: FormSectionProps) => {
  const form = useForm()
  const theme = useTheme()

  return (
    <Container maxWidth="md">
      <Box sx={{ mt: 7, mb: 12, display: 'flex' }} flexDirection="column">
        <FormWizard.Page validate={validate}>
          <Typography variant="h3" sx={{ mb: 8 }}>
            Do you own or rent your home?
          </Typography>
          <Grid container spacing={2} sx={{ mb: 14 }}>
            <Grid item xs={12} md={6}>
              <label htmlFor="no-mortgage" style={{ textAlign: 'center' }}>
                <FormRadio
                  id="no-mortgage"
                  name="livingStatus"
                  value="Own with no mortgage"
                  style={radioStyle}
                  overrideMuiStyle={radioOverrideMuiStyle}
                  onClick={async () => {
                    form.change('livingStatus', 'Own with no mortgage')
                    await form.submit()
                  }}
                />
                <Typography
                  component="span"
                  sx={{
                    ...textStyle,
                    backgroundColor: lighten(theme.palette.primary.main, 0.8),
                  }}
                >
                  Own with no mortgage
                </Typography>
              </label>
            </Grid>
            <Grid item xs={12} md={6}>
              <label htmlFor="with-mortgage" style={{ textAlign: 'center' }}>
                <FormRadio
                  id="with-mortgage"
                  name="livingStatus"
                  value="Own with mortgage"
                  style={radioStyle}
                  overrideMuiStyle={radioOverrideMuiStyle}
                  onClick={async () => {
                    form.change('livingStatus', 'Own with mortgage')
                    await form.submit()
                  }}
                />
                <Typography
                  component="span"
                  sx={{
                    ...textStyle,
                    backgroundColor: lighten(theme.palette.primary.main, 0.8),
                  }}
                >
                  Own with mortgage
                </Typography>
              </label>
            </Grid>
            <Grid item xs={12} md={6}>
              <label htmlFor="rent" style={{ textAlign: 'center' }}>
                <FormRadio
                  id="rent"
                  name="livingStatus"
                  value="Rent"
                  style={radioStyle}
                  overrideMuiStyle={radioOverrideMuiStyle}
                  onClick={async () => {
                    form.change('livingStatus', 'Rent')
                    await form.submit()
                  }}
                />
                <Typography
                  component="span"
                  sx={{
                    ...textStyle,
                    backgroundColor: lighten(theme.palette.primary.main, 0.8),
                  }}
                >
                  Rent
                </Typography>
              </label>
            </Grid>
            <Grid item xs={12} md={6}>
              <label htmlFor="with-parents" style={{ textAlign: 'center' }}>
                <FormRadio
                  id="with-parents"
                  name="livingStatus"
                  value="Living with parents"
                  style={radioStyle}
                  overrideMuiStyle={radioOverrideMuiStyle}
                  onClick={async () => {
                    form.change('livingStatus', 'Living with parents')
                    await form.submit()
                  }}
                />
                <Typography
                  component="span"
                  sx={{
                    ...textStyle,
                    backgroundColor: lighten(theme.palette.primary.main, 0.8),
                  }}
                >
                  Living with parents
                </Typography>
              </label>
            </Grid>
          </Grid>
        </FormWizard.Page>
      </Box>
    </Container>
  )
}

export default LivingStatus
